import * as React from 'react';

import { IconLogin24 } from './IconLogin24';
import * as styles from './Login.css';

interface ILoginProps {
  href: string;
  onClick?(event: React.MouseEvent<HTMLAnchorElement>): void;
}

export const Login: React.FC<ILoginProps> = ({ href, onClick }) => {
  return (
    <a href={href} className={styles['container']} onClick={onClick}>
      <IconLogin24 color="icon-primary-default" />
      Войти
    </a>
  );
};
